<template>
  <!--编辑型号含量-->
  <a-modal :title="title" visible @cancel="cancel">
    <ak-inputs v-model="data" :options="options" ref="input" />
    <a-form-item
      label="所属车间"
      :help="workShop ? '' : help1"
      :validate-status="workShop ? '' : validateStatus"
    >
      <a-select style="width: 100%" v-model="workShop">
        <a-select-option
          v-for="(w, index1) in workShops"
          :key="index1"
          :value="w.id"
          @click="handWorkShop(w.id)"
        >{{w.name}}</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item
      label="所属型号"
      :help="parentNode ? '' : help2"
      :validate-status="parentNode ? '' : validateStatus"
    >
      <a-select style="width: 100%" v-model="parentNode">
        <a-select-option
          v-for="(item, index2) in items"
          :key="index2"
          :value="item.id"
        >{{item.name}}</a-select-option>
      </a-select>
    </a-form-item>
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button :loading="loading" type="primary" @click="submit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import store from '@/store'
export default {
  data () {
    return {
      loading: false,
      validateStatus: '', // 校验状态
      help1: '', // 车间校验提示
      help2: '', // 型号校验提示
      data: {
        name: '' // 名称
      },
      workShop: null, // 车间
      parentNode: null, // 所属上级（大类）
      oriWorkShop: null, // 原车间
      oriParentNode: null, // 原所属上级(大类)
      options: [
        {
          name: 'name',
          note: '型号含量',
          validators: [
            (val) => val ? null : '型号含量不可为空'
          ]
        }
      ],
      workShops: [], // 车间可选项
      items: [] // 型号可选项
    }
  },
  async mounted () {
    this.getInit()
    if (this.record) {
      this.data.name = this.record.name
      if (this.record.workShop) {
        this.oriWorkShop = this.record.workShop.objectId
        this.workShop = this.record.workShop.objectId
        await this.inquiryModel(this.record.workShop.objectId)
      }
      if (this.record.parentNode) {
        this.parentNode = this.record.parentNode.objectId
        this.oriParentNode = this.record.parentNode.objectId
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('complete', 'cancel')
    },
    // 获取车间数据
    async getInit () {
      let res = await this.$modelAjax.getData('shopManagement', {
        params: {
          limit: 1000,
          where: {
            type: 'workShop',
            objectId: (store.state.user.allShopManagements === 'Yes' ? { $exists: true } : { $in: store.state.user.shopManagements })
          }
        }
      }).catch(e => {
        throw this.$notification['error']({
          message: '网络错误',
          description: '获取车间失败'
        })
      })
      this.workShops = res.results.map((e) => {
        return { name: e.name, id: e.objectId }
      })
    },
    // 选择车间，查询型号
    async handWorkShop (id) {
      if (!this.workShop || this.workShop !== id) {
        this.parentNode = null
        await this.inquiryModel(id)
      }
    },
    // 查询型号
    async inquiryModel (id) {
      let model = await this.$modelAjax.getData('shopManagement', {
        params: {
          limit: 1000,
          where: {
            type: 'model',
            parentNode: id
          }
        }
      }).catch(e => {
        throw this.$notification['error']({
          message: '网络错误',
          description: '获取车间型号失败'
        })
      })
      this.items = model.results.map((f) => {
        return { name: f.name, id: f.objectId }
      })
    },
    async submit () {
      // 验证必填项
      let erros = await this.$refs.input.validate()
      this.validateStatus = 'error'
      this.help1 = '所属车间不可为空'
      this.help2 = '所属型号不可为空'
      if (Object.keys(erros).length || !this.workShop || !this.parentNode) return
      // 新建
      this.loading = !this.loading
      if (!this.record) {
        await this.$modelAjax.post('shopManagement', {
          name: this.data.name,
          type: 'ratio',
          workShop: this.workShop,
          parentNode: this.parentNode
        }).catch(e => {
          this.loading = !this.loading
          throw this.$notification['error']({
            message: '保存失败',
            description: '保存失败，请重新尝试'
          })
        })
      }
      // 编辑
      if (this.record) {
        try {
          await this.$modelAjax.put('shopManagement', this.record.objectId, {
            name: this.data.name,
            workShop: this.workShop,
            parentNode: this.parentNode
          })
          if (this.workShop !== this.oriWorkShop) { // 若改变含量的所属车间，则修改此含量下产品的所属大类与所属车间
            this.$tkParse.post('/parentNode/editProportion', {
              objectId: this.record.objectId,
              workShop: this.workShop,
              model: this.parentNode,
              situation: 'changeWorkShop'
            })
          }
          if (this.workShop === this.oriWorkShop && this.parentNode !== this.oriParentNode) { // 若改变含量的所属大类，则修改此含量下产品的所属车间
            this.$tkParse.post('/parentNode/editProportion', {
              objectId: this.record.objectId,
              model: this.parentNode,
              situation: 'changeModel'
            })
          }
        } catch (e) {
          this.loading = !this.loading
          throw this.$notification['error']({
            message: '保存失败',
            description: '保存失败，请重新尝试'
          })
        }
      }
      this.$notification['success']({
        message: '保存成功',
        description: '数据已保存'
      })
      this.vm.refresh()
      this.$emit('complete', 'cancel')
    }
  },
  props: {
    vm: null,
    title: String,
    record: Object
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .ant-form-item-label > label::after {
    content: none !important;
  }
</style>
